import { BlockNoteEditor } from '@blocknote/core';
import { TextBlockSchema } from '../schema';
import getLinkMarkRange from './get-link-mark-range';

export default function unsetLinkMark(
  editor: BlockNoteEditor<TextBlockSchema>,
) {
  editor.exec((state, dispatch) => {
    if (!dispatch) {
      return false;
    }
    const linkType = state.schema.marks['link'];
    if (!linkType) {
      return false;
    }
    const { from, to, empty, $from } = state.selection;
    if (!empty) {
      dispatch(state.tr.removeMark(from, to, linkType));
      return true;
    }
    const range = getLinkMarkRange($from, linkType);
    if (!range) {
      return false;
    }
    dispatch(state.tr.removeMark(range.from, range.to, linkType));
    return true;
  });
  editor.focus();
}
